import './ShipperShow.scss';

import { EmailField, NumberField, RefreshButton, Show, TextField } from '@refinedev/antd';
import { useShow } from '@refinedev/core';
import { Typography } from 'antd';
import { useMemo } from 'react';

import PopupMenu from '@/components/general/PopupMenu';
import ProtectedDeleteButton from '@/components/protected/ProtectedDeleteButton';
import ProtectedEditButton from '@/components/protected/ProtectedEditButton';
import { usePermissionContext } from '@/contexts/PermissionContext';

const { Title } = Typography;
const ShipperShow = () => {
  const { hasPermission } = usePermissionContext();
  const hasMenuActions = useMemo(() => {
    return hasPermission('edit') || hasPermission('delete');
  }, [hasPermission]);
  const { query } = useShow();
  const { data, isLoading } = query;
  const record = data?.data;

  return (
    <Show
      isLoading={isLoading}
      headerButtons={({ refreshButtonProps, editButtonProps, deleteButtonProps }) => (
        <>
          <RefreshButton {...refreshButtonProps} hideText />
          {hasMenuActions && (
            <PopupMenu
              menuContent={
                <>
                  <ProtectedEditButton {...editButtonProps} type="text" />
                  <ProtectedDeleteButton {...deleteButtonProps} type="text" />
                </>
              }
            />
          )}
        </>
      )}>
      <div className="ShipperShow">
        <div>
          <Title level={5}>{'Id'}</Title>
          <NumberField value={record?.id ?? ''} />
        </div>
        <div>
          <Title level={5}>{'Nombre'}</Title>
          <TextField value={record?.name} />
        </div>
        <div>
          <Title level={5}>{'Dirección'}</Title>
          <TextField value={record?.address ?? '-'} />
        </div>
        <div>
          <Title level={5}>{'Teléfono'}</Title>
          <TextField value={record?.phone ?? '-'} />
        </div>
        <div>
          <Title level={5}>{'Teléfono 2'}</Title>
          <TextField value={record?.phone2 ?? '-'} />
        </div>
        <div>
          <Title level={5}>{'Email'}</Title>
          <EmailField value={record?.email ?? '-'} />
        </div>
        <div>
          <Title level={5}>{'Link de tracking'}</Title>
          <TextField value={record?.tracking_link ?? '-'} />
        </div>
      </div>
    </Show>
  );
};

export default ShipperShow;
